import {
  cn 
} from "@/lib/utils"

function Skeleton({
  className,
  ...props
  // eslint-disable-next-line no-undef
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("bg-muted animate-pulse rounded-md", className)}
      {...props}
    />
  )
}

export {
  Skeleton 
}

